import AddPayeeModal from './AddPayeeModal';

export default AddPayeeModal;
